export default "__VITE_ASSET__BcOP67uc__"